import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { archivePlan } from './store/plans/actions';

import Button from 'shared/button';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import Options from 'components/form/managed_input/options';

export function ArchiveModal({ archivePlan, plan, plans, show, onHide }) {
  const handleArchive = () => {
    archivePlan(plan, newPlanId === 'none' ? null : newPlanId);
    onHide();
  };

  const [newPlanId, setNewPlanId] = useState(null);

  return (
    <Modal show={show} onHide={onHide} onReset={() => setNewPlanId(null)}>
      <Modal.Header closeButton>
        Archive Plan
      </Modal.Header>
      <Modal.Body>
        <div className="form archive-modal">
          <p>Archiving this commission plan will do the following:</p>
          <ul>
            <li>Remove all current assignees</li>
            <li>Change the name of the plan to "<b>{plan.name} - Archived</b>"</li>
            <li>Update open vouchers currently set to this plan to the plan you select below</li>
          </ul>
          <ManagedFormGroup
            className="mb-2"
            includeBlank="Select a Plan"
            label="Update current vouchers to use this plan"
            required
            type="select"
            value={newPlanId}
            onValueChange={setNewPlanId}
          >
            <option value="none">No Plan</option>
            <Options
              labelName="name"
              options={plans.filter(p => !p.archived && p.id !== plan.id)}
              valueName="id"
            />
          </ManagedFormGroup>

          <small className="text-muted">Any users not assigned to this plan will be updated to “No Plan”</small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button.Cancel onClick={onHide} />
        <Button.Danger disabled={!newPlanId} onClick={handleArchive}>Archive</Button.Danger>
      </Modal.Footer>
    </Modal>
  );
}

ArchiveModal.propTypes = {
  archivePlan: PropTypes.func.isRequired,
  plan: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  plans: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
  show: PropTypes.bool,
  onArchive: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  plans: state.plans,
});

const mapDispatchToProps = {
  archivePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveModal);
